import { Box, Button, styled } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface TabButtonGroupProps {
  selectedTab: 'result' | 'history';
  handleTabChange: (tab: 'result' | 'history') => void;
  responsesCount: number;
}

// Styled container with spacing between buttons
const SwitchContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  borderRadius: '30px',
  overflow: 'hidden',
  gap: '8px', // Small gap between buttons
});

// Styled button with minimal animation
const StyledButton = styled(Button)(({ selected }: { selected: boolean }) => ({
  flex: 1, // Equal width for buttons
  height: '50px', // Adjust height
  backgroundColor: selected ? '#0EAEC1' : '#E0E0E0', // Blue for selected, light gray for others
  color: selected ? '#fff' : '#0EAEC1', // White text for selected, blue for others
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 'bold',
  borderRadius: '30px', // Fully rounded corners
  padding: '0 16px',
  transition: 'background-color 200ms, color 200ms', // Shortened animation
  '&:hover': {
    backgroundColor: selected ? '#0EAEC1' : '#D6D6D6', // Slight hover effect for non-selected buttons
  },
}));

const TabButtonGroup: React.FC<TabButtonGroupProps> = ({
                                                         selectedTab,
                                                         handleTabChange,
                                                         responsesCount,
                                                       }) => {
  return (
    <SwitchContainer>
      {/* Result Button */}
      <StyledButton
        selected={selectedTab === 'result'}
        onClick={() => handleTabChange('result')}
      >
        <FormattedMessage id="home.textarea.result" />
      </StyledButton>

      {/* History Button */}
      <StyledButton
        selected={selectedTab === 'history'}
        onClick={() => handleTabChange('history')}
      >
        <FormattedMessage id="home.textarea.history" />
        {responsesCount > 0 && ` (${responsesCount})`}
      </StyledButton>
    </SwitchContainer>
  );
};

export default TabButtonGroup;
